import { useApplicationContext } from '~/common/context';
import { TilesHelpers } from '~/connect/helpers';

export function useActiveTiles() {
  const { auth, application } = useApplicationContext();
  return TilesHelpers.resolveVariant(auth.roles, application.features);
}
